module.exports = __webpack_public_path__ + "static/media/back.64d9f84b.jpg";